import { Card, CardBody, CardHeader, Col } from "reactstrap";
import { H3, P, SVG } from "../../../../AbstractElements";
import CardHeaderDropdown from "../../../../CommonElements/CommonCardHeader/CardHeaderDropdown";
import { TopDealerHeading } from "../../../../utils/Constant";
import TopDealerCarousel from "./TopDealerCarousel";

const TopDealer = () => {
  return (
    <Col xl="7">
      <Card className="top-dealer-sec">
        <CardHeader className="card-no-border">
          <div className="header-top d-sm-flex justify-content-between align-items-center">
            <H3>{TopDealerHeading}</H3>
            <div className="center-content">
              <P className="d-flex">
                <span className="bg-light-primary me-1">
                  <SVG iconId="arrow-down" />
                </span>
                <span className="font-primary me-1">635 Dealer</span>
                <span>65% More Than Last Year</span>
              </P>
            </div>
            <CardHeaderDropdown mainTitle="Yearly" firstItem="Today" secondItem="Tomorrow" thirdItem="Yesterday" />
          </div>
        </CardHeader>
        <CardBody className="overflow-hidden py-0">
          <TopDealerCarousel />
        </CardBody>
      </Card>
    </Col>
  );
};

export default TopDealer;
